// eslint-disable-next-line prettier/prettier
export enum AppElementAttributeVisibility {
  Hidden = 0,
  ReadOnly,
  Edit,
  AsPerRole,
}